import Alert from 'react-s-alert';
import classNames from 'classnames';
import ClearingHouseModal from './clearing-house-modal';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import PaginatorCustom from '../../../../components/paginationCustom';
import React from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField, renderToggleButton} from '../../../../components/reduxFields';
import SortingCustom from '../../../../components/SortingCustom';
import { getClearingHouseList, deleteClearingHouseData, UpdateClearingHouseActiveStatus} from './actions/ClearingHouseActions';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../actions/utilAction';

class ClearingHouse extends React.Component {

  constructor(props) {
    super(props);
    this.state = ({
      clearingHouseId: null,
      open: false,
      activeToggleValues: [],
    });
    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };
    this.handleSearchClearingHouse = this.handleSearchClearingHouse.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  };

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number || 1,
    };
    this.props.getClearingHouseList(searchObj);
  }

  componentWillMount() {
    this.loadData();

  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.clearingHouseDataAdded && this.props.clearingHouseDataAdded !== nextProps.clearingHouseDataAdded) {
      this.loadData();
    }
    if (nextProps.clearingHouseDataDeleted && this.props.clearingHouseDataDeleted !== nextProps.clearingHouseDataDeleted) {
      this.loadData();
    }
    if (nextProps.clearingHouseData && nextProps.clearingHouseData !== this.props.clearingHouseData) {
      let usersArray = nextProps.clearingHouseData.data;
      let activeToggleValues = new Array(usersArray.length).fill({});
      let index = 0;
      usersArray.map((obj) => {

        if (activeToggleValues.indexOf(obj) === -1) {
          activeToggleValues.splice(index, 1, obj);
          index = index + 1;
        }
        return activeToggleValues;
      });
      this.setState({
        activeToggleValues: activeToggleValues,
      });
    }
    if (nextProps.clearingHouseDataUpdate && this.props.clearingHouseDataUpdate !== nextProps.clearingHouseDataUpdate) {
      this.loadData();
    }
  };
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, clearingHouseId: null });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEditClick = (event, clearingHouseObj) => {
    Alert.closeAll();
    this.setState({ open: true, clearingHouseId: clearingHouseObj.id });
  };

  handleAlertClick = (event, id) => {
    this.props.deleteClearingHouseData(id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, clearingHouseObj) => {
    alertConfirmation('Are you sure want to delete this clearing house data?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: clearingHouseObj.id,
      },
    });
  };

  handleActiveAlertClick = async(e,index, userID) => {
    let activeToggleValues = this.state.activeToggleValues;
    activeToggleValues[index].isActive = !activeToggleValues[index].isActive;
    this.setState({
      activeToggleValues: activeToggleValues,
    });
    try{
      await this.props.UpdateClearingHouseActiveStatus(userID, this.state.activeToggleValues[index].isActive);
      this.loadData()
    }catch(error){
      console.error('Error:', error);
    }
    Alert.closeAll();
  }

  onActiveToggle(e, index, clearingHouseObj) {
    let warningMsg = 'Are you sure you want to activate this clearinghouse? All future claims will be submitted to this clearinghouse.'
    alertConfirmation(warningMsg, {
      html : true,  
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleActiveAlertClick,
        id: index,
        userID: clearingHouseObj.id,
      },
    });
  };

  handleSearchClearingHouse() {
    return null;
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ClearingHouseForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.loadData();
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }

  renderClearingHouseList(clearingHouseList) {
    clearingHouseList = clearingHouseList || [];

    if (!clearingHouseList.length) {
      return (
        <tr><td colSpan="4" className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</td></tr>
      );
    }
    return clearingHouseList.map((clearingHouseObj, index) => {
      return (
        <tr key={index}>
          <td >{clearingHouseObj.clearingHouseName}</td>
          <td >{clearingHouseObj.senderID}</td>
          <td >{clearingHouseObj.receiverID}</td>
          <td >
            <Field className="no_margin"
              name="active_status"
              toggled={this.state.activeToggleValues[index] && this.state.activeToggleValues[index].isActive ? this.state.activeToggleValues[index].isActive : false}
              component={renderToggleButton}
              onChange={(e) => this.onActiveToggle(e, index, clearingHouseObj)}
            />
          </td>
            <td >
              <button onClick={(e) => this.handleEditClick(e, clearingHouseObj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
              <button onClick={(e) => this.handleDeleteClick(e, clearingHouseObj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
            </td>  
        </tr>
      );
    });

  }

  render() {
    const { handleSubmit, clearingHouseData } = this.props;
    let clearingHouseList = (clearingHouseData && clearingHouseData.data) || [];
    let clearingHouseMeta = (clearingHouseData && clearingHouseData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open && <ClearingHouseModal closeDialog={this.handleClose} clearingHouseId={this.state.clearingHouseId}/>}
        <h2 className="page_title">Manage Clearing House</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {/* {this.props.addPermission &&  */}
                  <CommonButton label="Add Clearing House" primary={true} onTouchTap={this.handleOpen} />
                  {/* } */}
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchClearingHouse)}>
                        <Field
                          name="ClearingHouseName"
                          floatingLabelText="Search"
                          maxLength="10"
                          fullWidth={true}
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <CommonButton label = 'Reset' className="grey_btn" onTouchTap={this.handleResetButton} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive mt-15">
              <table className={tableClass}>
                <thead>
                  <tr>
                    <th width="35%">
                      <SortingCustom noSort={!clearingHouseList.length} setSortColumn={this.setSortColumn} columnName='ClearingHouseName' displayName='Clearing House Name'/>
                    </th>
                    <th width="20%">
                      <SortingCustom noSort={!clearingHouseList.length} setSortColumn={this.setSortColumn} columnName='SenderID' displayName='Sender Id'/>
                    </th>
                    <th width="15%">
                      <SortingCustom noSort={!clearingHouseList.length} setSortColumn={this.setSortColumn} columnName='ReceiverID' displayName='Receiver Id'/>
                    </th>
                    <th width="10%">Active</th>
                    <th width="20%">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderClearingHouseList(clearingHouseList)}
                </tbody>
              </table>
            </div>
            {clearingHouseMeta && clearingHouseMeta['totalPages'] ?
              <PaginatorCustom data={clearingHouseMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
              : null}
          </div>
        </div>
      </div>
    );
  }

}

ClearingHouse = reduxForm({
  form: 'ClearingHouseForm',
})(ClearingHouse);


function mapStateToProps(state) {
  return {
    loading: state.superAdminClearingHouse.loading,
    clearingHouseData: state.superAdminClearingHouse.clearingHouseList,
    clearingHouseDataUpdate: state.superAdminClearingHouse.clearingHouseActiveStatus,
    clearingHouseDataDeleted: state.superAdminClearingHouse.clearing_house_deleted,
    clearingHouseDataAdded: state.superAdminClearingHouse.clearing_house_added,
  };
}

export default connect(mapStateToProps, { getClearingHouseList, deleteClearingHouseData,UpdateClearingHouseActiveStatus})(ClearingHouse);


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/clearing-house/clearing-house.js